import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import HotelsSkeleton from '../components/HotelsSkeleton/HotelsSkeleton';
import * as constants from '../util/constants';
import helpers from '../util/helpers';

class AppGlobalOfferSearchPage extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      allOffers: [],
      heading: '',
      subHeading: '',
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.location = helpers.docCookies.getItem(constants.COOKIE_KEY_OFFERS_SEARCH_LOCATION);
    this.offersType = helpers.docCookies.getItem(constants.COOKIE_KEY_OFFERS_SEARCH_TYPE);
    this.offersBrands = '';

    const searchOffersForm = $('.search-offers');
    if (searchOffersForm.length) {
      this.offersBrands = searchOffersForm.data('offers-brands');
    }

    // Bind "this"
    this.loadSearchResults = this.loadSearchResults.bind(this);
    this.loadMoreSearchResults = this.loadMoreSearchResults.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  loadSearchResults() {
    // Stop loading old results
    if (this.state.loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    // Reset state
    this.setState(this.initialState);

    // Params
    const data = {
      'action': constants.ACTION_GET_GLOBAL_OFFERS,
      'location': this.location,
      'offersType': this.offersType,
      'offersBrands': this.offersBrands,
      'offset': 0,
    };

    // Send request
    axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const offersCount = response.data['offers_count'];
          const offers = [...response.data['offers']];

          if (0 === offersCount) {
            this.setState({
              heading: 'Oops',
              subHeading: 'No offers found',
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          } else {
            this.setState({
              loading: false,
              allOffers: offers,
              heading: `${offersCount}` + (1 === offersCount ? ' offer' : ' offers'),
              subHeading: '',
              loadMoreLoading: false,
              loadedAll: offersCount == offers.length,
            });
          }
        } else {
          this.setState({
            heading: 'Oops',
            subHeading: 'Something went wrong.',
            loading: false,
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMoreSearchResults() {
    const {
      allOffers,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      // Params
      const data = {
        'action': constants.ACTION_GET_GLOBAL_OFFERS,
        'location': this.location,
        'offersType': this.offersType,
        'offersBrands': this.offersBrands,
        'offset': allOffers.length,
      };

      // Send request
      axios.post(window.Rydges['ajaxUrl'], qs.stringify(data)).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const offersCount = response.data['offers_count'];
            const offers = [
              ...allOffers,
              ...response.data['offers'],
            ];

            this.setState({
              loading: false,
              allOffers: offers,
              loadMoreLoading: false,
              loadedAll: offersCount == offers.length,
            });
          } else {
            this.setState({
              heading: 'Oops',
              subHeading: 'Something went wrong.',
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  componentDidMount() {
    // Load results on first page load
    this.loadSearchResults();

    // Reload results on input changes
    document.addEventListener(constants.EVENT_SUBMIT_CLICKED_SEARCH, () => {
      const location = helpers.docCookies.getItem(constants.COOKIE_KEY_OFFERS_SEARCH_LOCATION);
      const offersType = helpers.docCookies.getItem(constants.COOKIE_KEY_OFFERS_SEARCH_TYPE);

      if (this.location !== location || this.offersType !== offersType) {
        this.location = location;
        this.offersType = offersType;
        this.loadSearchResults();
      }
    });
  }

  componentDidUpdate() {
    // Equal height for elements
    $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);
  }

  render() {
    const {
      loading,
      allOffers,
      heading,
      subHeading,
      loadMoreLoading,
      loadedAll,
    } = this.state;

    return (
      <React.Fragment>
        <h2 className="skeleton-shine">{heading}</h2>

        {(loading || subHeading.length > 0) && (
          <p className="skeleton-shine">{subHeading}</p>
        )}

        <div className="hotel-result-container pt-4">
          {
            !loading && (
              <div className="hotel-network-wrapper">
                <div className="hotel-wrapper mb-3">
                  {
                    allOffers.map((offer, i) =>
                      <a href={offer['url']} className="single-hotel d-block" key={i}>
                        <div className="single-hotel-wrapper">
                          <div className="preview-images bg-center" style={{backgroundImage: `url(${offer['featured_image']})`}} />
                          <div className="hotel-info balance-elements">
                            <div className="name" dangerouslySetInnerHTML={{__html: offer['name']}}/>
                            {
                              offer['hotel'].length > 0 && (
                                <div className="hotel">{offer['hotel']}</div>
                              )
                            }
                            {
                              offer['description'].length > 0 && (
                                <div className="description">{offer['description']}</div>
                              )
                            }
                            {
                              offer['distance'].length > 0 && (
                                <div className="distance">{offer['distance']}</div>
                              )
                            }
                            {
                              offer['price'].length > 0 && (
                                <div className="price">From {`${offer['currency']} ${offer['price']}`} | Night</div>
                              )
                            }
                            {
                              offer['price'].length > 0 && offer['discount_text'].length > 0 && (
                                <div className="discount">{offer['discount_text']}</div>
                              )
                            }
                          </div>
                        </div>
                      </a>
                    )
                  }
                </div>
              </div>
            )
          }
          {
            (loading || loadMoreLoading) && (
              <HotelsSkeleton/>
            )
          }
        </div>
        <div className="text-center">
          <button className="btn btn-red btn-lg btn-border-red btn-load-more mt-3" disabled={loading || loadMoreLoading || loadedAll } onClick={this.loadMoreSearchResults}>
            {!loadedAll ? 'Load More' : 'That\'s All'}
          </button>
        </div>
      </React.Fragment>
    );
  }
}

export default {
  init() {
    // JavaScript to be fired on init
  },
  finalize() {
    // JavaScript to be fired on loaded

    // Results
    const resultsWrapper = $('#search-offers-results-wrapper');

    if (resultsWrapper.length) {
      setTimeout(function() {
        ReactDOM.render(<AppGlobalOfferSearchPage/>, resultsWrapper[0]);
      }, 1000);
    }

    const searchOffersForm = $('.search-offers');
    if (searchOffersForm.length) {
      const offerLocationsSearch = searchOffersForm.find('.where');
      const offerTypesSearch = searchOffersForm.find('.offers-search');
      const offerLocation = helpers.getParameterByName('location');
      const offerType = helpers.getParameterByName('offer-type');
      const offerLocationCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_OFFERS_SEARCH_LOCATION);
      const offerTypeCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_OFFERS_SEARCH_TYPE);
      const params = helpers.getParameters();

      // Set url params to cookie
      if (offerLocation != null && offerLocation.length) {
        params['location'] = offerLocation;
        offerLocationsSearch.val(offerLocation);
        helpers.docCookies.setItem(offerLocationsSearch.data('cookie-location'), offerLocation, 1500, '/');
      }
      if (offerType != null && offerType.length) {
        params['offer-type'] = offerType;
        offerTypesSearch.val(offerType);
        helpers.docCookies.setItem(offerTypesSearch.data('cookie-offer-type'), offerType, 1500, '/');
      }

      // Set cookie to url params
      if ((offerLocation == null && offerLocationCookie) || (offerType == null && offerTypeCookie)) {
        if (offerLocationsSearch.length && offerLocation == null && offerLocationCookie) {
          params['location'] = offerLocationCookie;
        }
        if (offerTypesSearch.length && offerType == null && offerTypeCookie) {
          params['offer-type'] = offerTypeCookie;
        }
      }

      // Push params to url
      helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

      const handleUrlParamsOnInput = function() {
        const params = helpers.getParameters();

        if (offerLocationsSearch.length && offerLocationsSearch.val() !== '') {
          params['location'] = offerLocationsSearch.val();
        } else {
          delete params['location'];
        }
        if (offerTypesSearch.length && offerTypesSearch.val() !== '') {
          params['offer-type'] = offerTypesSearch.val();
        } else {
          delete params['offer-type'];
        }

        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');
      };

      const submitButton = searchOffersForm.find('button[type="submit"]');

      searchOffersForm.find('.where, .offer')
        .on('input', function() {
          const _this = $(this);

          if (_this.val().length === 0) {
            handleUrlParamsOnInput();

            submitButton.prop('disabled', false);
          } else {
            submitButton.prop('disabled', true);
          }
        })
        .on('input_changed.rsd-ac', function() {
          handleUrlParamsOnInput();

          submitButton.prop('disabled', false);
        });

      // Trigger search on submit button clicked
      let timeout;
      submitButton.on('click', function(e) {
        e.preventDefault();

        clearTimeout(timeout);

        timeout = setTimeout(function() {
          document.dispatchEvent(helpers.initNewEvent(constants.EVENT_SUBMIT_CLICKED_SEARCH));
        }, 1000);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalOfferSearch.js